// Generated by GitHub Copilot
import React, { useState } from "react";
import {
  Modal,
  Button,
  Form,
  InputGroup,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { FaClipboard, FaCheck } from "react-icons/fa";
import { trackModernUIInteraction } from "../../utils/modernUITracking";

function ShareLinkModal({ show, onHide, url, problemNumber }) {
  const [copied, setCopied] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setShowToast(true);
      trackModernUIInteraction('Share.LinkGenerated', { problemNumber });

      // Reset copied state after 2 seconds
      setTimeout(() => setCopied(false), 2000);

      // Auto-hide toast after 3 seconds
      setTimeout(() => setShowToast(false), 3000);
    } catch (err) {
      console.error("Failed to copy link:", err);
      alert(`Failed to copy. Please copy manually: ${url}`);
    }
  };

  const handleClose = () => {
    setCopied(false);
    setShowToast(false);
    onHide();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Share This Page</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-3">
            Copy the link below to share this page with your team:
          </p>
          <InputGroup>
            <Form.Control
              type="text"
              value={url}
              readOnly
              style={{
                fontFamily: "monospace",
                fontSize: "0.9rem",
                backgroundColor: "#f8f9fa",
              }}
            />
            <Button
              variant={copied ? "success" : "primary"}
              onClick={handleCopyToClipboard}
              title="Copy to clipboard"
            >
              {copied ? (
                <>
                  <FaCheck className="me-2" />
                  Copied!
                </>
              ) : (
                <>
                  <FaClipboard className="me-2" />
                  Copy
                </>
              )}
            </Button>
          </InputGroup>
        </Modal.Body>
      </Modal>

      {/* Toast notification */}
      <ToastContainer
        position="top-end"
        className="p-3"
        style={{ zIndex: 9999 }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
          bg="success"
        >
          <Toast.Header>
            <strong className="me-auto">Link Copied!</strong>
          </Toast.Header>
          <Toast.Body className="text-white">
            The URL has been copied to your clipboard.
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}

export default ShareLinkModal;
